import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import User from '@/users/entities/user'
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import moment, { Moment } from 'moment'

@Component
export default class UsersTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public users!: User[]

  get headers() {
    return [
      { text: 'Name', value: 'name', sortable: true },
      { text: 'E-Mail', value: 'email', sortable: true },
      { text: 'Adresse', value: 'address', sortable: false },
      { text: 'Benutzerrolle', value: 'role', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Erzeugt am', value: 'created', sortable: true },
      { text: 'Erster Abschluß', value: 'firstAcceptedDate', sortable: false },
      { text: 'Kündigung', value: 'cancellationDate', sortable: true },
      { text: 'Rechnung', value: 'alreadyInvoiced', sortable: true },
      {
        text: '',
        value: 'action',
        sortable: false,
        class: 'td-w-shrink',
        align: 'end',
      },
    ]
  }

  private edit(user: User) {
    this.$emit('edit', user)
  }

  private impersonate(user: User) {
    this.$emit('impersonate', user)
  }

  private enable(user: User) {
    this.$emit('enable', user)
  }

  private disable(user: User) {
    this.$emit('disable', user)
  }

  private deleteUser(user: User) {
    if (confirm('Soll der Benutzer wirklich gelöscht werden?')) {
      this.$emit('delete', user)
    }
  }

  public formatDate(date: string): string {
    if (!date) {
      return ''
    }
    return moment(date).format('DD.MM.YYYY')
  }
}
